import React from 'react';
import { Button } from './ui/button';
import { useTranslation } from '../i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    // Log to backend for remote debugging
    try {
      fetch((process.env.REACT_APP_BACKEND_URL || '') + '/api/health', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ error: error?.toString(), stack: error?.stack?.substring(0, 500), component: errorInfo?.componentStack?.substring(0, 300) }),
      }).catch(() => {});
    } catch(e) {}
    try { import('@sentry/react').then(Sentry => Sentry.captureException(error, { extra: errorInfo })).catch(() => {}); } catch(e) {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-5">
          <div className="text-center max-w-md">
            <h1 className="text-4xl font-bold text-foreground mb-2">Something went wrong</h1>
            <p className="text-muted-foreground mb-6">
              An unexpected error occurred. Try refreshing the page.
            </p>
            <div className="flex gap-3 justify-center">
              <Button onClick={() => window.location.reload()}>
                Refresh Page
              </Button>
              <Button variant="outline" onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = '/dashboard';
              }}>
                Go to Dashboard
              </Button>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="mt-6 text-left text-xs text-red-500 bg-red-50 dark:bg-red-950 p-4 rounded-lg overflow-auto max-h-48">
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
